import React from 'react'
import { Dialog } from "@material-ui/core";
import { Icon } from "@dashboard/common/src/component/Component";
import { dataCollectionInfo, dataSaftey, dataSecurity, dataSharing, userDataCollection } from './dataSafteyContent';
import lock from '../../images/lock.png'
import drive from '../../images/drive.png'
import minus from '../../images/minus.png'
import share from  '../../images/share.png'
import logo from  '../../images/koshlogo.png'


const tabStyles = {
    paddingLeft: 10,
    paddingRight: 30, 
    marginTop: 15
}
const paraStyles = {
    marginLeft: 5, 
    marginBottom: 10
}

const DataSafetyDetails = ({ showDataSafetyDetails, showSafetyDetails, hideSafteyDetails }) => {

    const centerLine = () =>{
        return(
            <div style={{ display: 'flex', margin: 5, width: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ height: 1, width: '97%', background: 'gray'}}></div>
            </div>
        )
    }

    const showData = (header, data, image) =>{
        return(
            <div className='textStyle' style={tabStyles}>
                {image &&
                 <div style={{ height: 50, width: 50, marginBottom: 15, marginTop: 25, display: 'flex', alignItems: 'center', 
                            justifyContent: 'center', borderRadius: 180, background: '#F0F0F0'}}
                >
                    <img src={image} height={25} width={25} />
                 </div>
                }
                <h2 style={paraStyles}>{header}</h2>
                <p style={{ margin: 5, marginBottom: 15}}>{data}</p> 
            </div>
        )
    }
  return (
    <Dialog open={showDataSafetyDetails} maxWidth='xs' fullScreen style={{ minHeight:'100%'  }} onClose={hideSafteyDetails}>
        <div style={{ backgroundColor:'#E5E4E2',}}>
            {/* Up Container */}
            <div className='textStyle' style={{ height: '18vh', width: '100%' }}>
                <div style={{ height: 50, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <button style={{ height: 30, width: 50, display: 'flex', fontSize: 20,  justifyContent: 'center', 
                                    alignItems: 'center', color: 'black', background: 'none', border: 'none'}} 
                    onClick={hideSafteyDetails}>
                        <Icon className="icon icon-circle bg-light ni ni-arrow-left"></Icon>
                    </button>
                </div>
                <div style={{ display: 'flex', marginLeft: 30, marginTop: 10, alignItems: 'center'}} >
                    <div style={{ background: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 62, height: 62 }}>
                        <img src={logo} height={60} width={60} />
                    </div>
                    <div style={{ marginLeft: 20, display: 'flex', flexDirection: 'column'}}>
                        <h2 style={{ color: 'black'}}>Kosh - Loan App</h2>
                        <p style={{ color: '#696969' }}>Adhikosh Financial Advisory</p>
                    </div>
                </div>
            </div>

            {/* Down Container */}
            <div style={{ borderRadius: 15, padding: 10, background: 'white', marginTop: -5}} >
                {showData('Data Saftey', dataSaftey)}
                {centerLine()}
                {showData('No data shared with third parties', dataSharing, share)}
                {centerLine()}
                {showData('Data collected', dataCollectionInfo, drive)}
                <div style={{ display: 'flex', flexDirection: 'column', margin: 5}}>
                    {
                        userDataCollection.map((data, index)=>{
                            return(
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 19, marginTop: 10 }}>
                                    <div style={{ marginTop: -5, fontSize: 22}}>
                                        <Icon className={`ni ${data.icon}`} />
                                    </div>
                                    <div style={{ display : 'flex', marginLeft: 10, flexDirection: 'column' }}>
                                        <h4>{data.name}</h4>
                                        <span style={{ marginTop: -5}}>{data.details}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {centerLine()}
                {showData('Security practices', '', lock)}
                <div style={{ display: 'flex', flexDirection: 'column', margin: 5}}>
                    {
                        dataSecurity.map((data, index)=>{
                            return(
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 19, marginTop: 10 }}>
                                    <div style={{ height: 30, width: 30, marginTop: -5, display: 'flex', justifyContent: 'center'
                                    ,alignItems: 'center', borderRadius: 180, background: '#F0F0F0'}}>
                                        <img src={data.icon === 'lock' ? lock : minus} height={16} width={16} />
                                    </div>
                                    <div style={{ display : 'flex', flex: 1, marginLeft: 10, flexDirection: 'column' }}>
                                        <h4>{data.name}</h4>
                                        <p style={{ marginTop: -5}}>{data.details}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </Dialog>
  )
}

export default DataSafetyDetails